function hashString(value: string): string {
  let hash = 5381;

  for (let index = 0; index < value.length; index++) {
    hash = ((hash * 33) ^ value.charCodeAt(index)) >>> 0;
  }

  return hash.toString(36);
}

// Identifies the exact SRP URL, so a replayed back matches the page that was left and another link does not.
export function getSrpResumeKey(
  pathname: string,
  queryEntries: Array<[string, string]>
): string {
  const query = queryEntries
    .map(([name, value]) => `${name}=${value}`)
    .sort()
    .join('&');

  return hashString(`${pathname}?${query}`);
}

export function toQueryEntries(
  params: Record<string, string | Array<string> | undefined>
): Array<[string, string]> {
  return Object.entries(params).flatMap(([name, value]) =>
    value === undefined
      ? []
      : (Array.isArray(value) ? value : [value]).map(
          (item): [string, string] => [name, item]
        )
  );
}
